import {useDispatch, useSelector} from 'react-redux';
import {ErrorMessageAlert, SuccessMessageAlert} from './index';
import {useEffect} from 'react';
import { resetAlert } from '../../store/actions';

const PageAlert = ({className}) => {
  const error = useSelector(state => state.page_alert.error);
  const successMessage = useSelector(state => state.page_alert.success);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetAlert());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  const alertClassName = `mb-[16px] ${className || ''}`;
  return (
    <>
      <SuccessMessageAlert className={alertClassName} success={successMessage} />
      <ErrorMessageAlert className={alertClassName} error={error} />
    </>
  );
};

export default PageAlert;